// eslint-disable-next-line no-unused-vars
/*global google theme_paths*/

import GMap from '../util/GMap';
import GMapStyle from '../config/googlemap-style.json';
import AjaxForm from '../util/AjaxForm';

export default {
  init() {
    // JavaScript to be fired on all pages
    this.gmaps.init();
    this.ajax_form();
    this.paypal_form();

    $(window).load(() => {
		this.render();
	});
  },
  render() {
		this.gmaps.init();
	},
  gmaps: {
		init: function() {

			// console.log('gmaps_init');
			

			$(window).on('gmaps_loaded', () => {
				$('body').addClass('gmaps_loaded');
				this.setup_maps();
			});

			this.setup_maps();
		},
		setup_maps: function() {
			
			if(!$('body').hasClass('gmaps_loaded')) return;

			$('.gmap').each(function(i, el){

				var $el = $(el),
					options = {};

				if($el.data('lat') !== undefined && $el.data('lng') !== undefined) {
					options.center = {lat: parseFloat($el.data('lat')), lng: parseFloat($el.data('lng'))};
				}

				if($el.data('zoom') !== undefined) {
					options.zoom = $el.data('zoom');
				}

				options.styles = GMapStyle;
				options.marker_icon = {
					url: theme_paths.marker_icon,
					// This marker is 50 pixels wide by 50 pixels high.
					size: new google.maps.Size(30, 42),
					scaledSize: new google.maps.Size(30, 42),
					// The origin for this image is (0, 0).
					origin: new google.maps.Point(0, 0),
					// The anchor for this image is the base of the flagpole at (0, 32).
					anchor: new google.maps.Point(15, 42),
				};

				options.cluster = false;
				options.cluster_icon = theme_paths.cluster_icon;
				options.cluster_options = {
					//maxZoom: 1,
					// gridSize
					styles: [{
						url: theme_paths.cluster_icon,
						height: 60,
						width: 60,
						anchor: [0, 0],
						textColor: '#fff',
						textSize: 12,
					}],
				};

				if(!$(el).hasClass('gmap-init')) {
					new GMap(el, options);
					$(el).addClass('gmap-init');
				} else {
					$el.data('gmap').update();
				}
			});

			// $(window).trigger('resize');

		},
	},
	ajax_form() {
		
		$('form.ajax-form').each((i, el) => {
			new AjaxForm(el, {
				action : $(el).attr('action'),
				// store_query_id : $(el).data('store-query-id'),
				on_success : ( /*data*/ ) => {
					// console.log('on_success', data);
					// change
				},
				after_done : () => {
					// this.cosdf();
					// console.log($(el).find())
					// $(el).find('.collapse.show').collapse('hide');
					
					// images.init();
					// this.render();

					// if(!$(el).hasClass('lazy-load')) {
					// 	smoothScroll($(el));
					// }
				},
				after_read_from_storage : () => {
					// var scrollTop = $(window).scrollTop();
					// $('select').selectpicker('refresh');
					// $(window).scrollTop(scrollTop);
				},
			});
		});
	},
	paypal_form() {
		
			$('input[type=checkbox]').change(function() {
		        if ($('input[type=checkbox]').is(':checked')) {
		        	$('input[name=cmd]').val('_xclick-subscriptions');
		        	$('#recurdetails').show();
		        } else {
		        	$('input[name=cmd]').val('_donations');
		        	$('#recurdetails').hide();
		        }
		    });
	},

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js